module.exports = __webpack_public_path__ + "img/Img37_Reconciliation-2_20150531_122924.15f8aa73.jpg";